import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
import { useSessionStore } from '../stores/sessionStore';
import { ChatView } from '../components/chat/ChatView';
import { Button } from '../components/common/ui';
export function ChatSessionPage() {
  useScreenInit();
  const navigate = useNavigate();
  const {
    sessionId
  } = useParams();
  const exists = useSessionStore(s => s.sessions.some(se => se.sessionId === sessionId));
  return <div className="flex h-[calc(100vh-3.5rem)] w-full flex-col px-4 py-4 sm:px-6" data-id="element-463">
      <button onClick={() => navigate('/history-sessions')} className="mb-3 inline-flex w-fit items-center gap-1.5 text-sm text-slate-400 hover:text-slate-200" data-id="element-464">
        <ArrowLeftIcon className="h-4 w-4" data-id="element-465" /> 返回历史会话
      </button>
      {sessionId && exists ? <div className="min-h-0 flex-1" data-id="element-466">
          <ChatView sessionId={sessionId} data-id="element-467" />
        </div> : <div className="flex flex-1 flex-col items-center justify-center text-center text-slate-500" data-id="element-468">
          <p className="text-sm" data-id="element-469">会话不存在或已被删除</p>
          <Button className="mt-3" onClick={() => navigate('/history-sessions')} data-id="element-470">
            返回历史会话
          </Button>
        </div>}
    </div>;
}